declare global {
  interface Window {
    hj: any;
    _hjSettings: any;
  }
}

export const initializeHotjar = () => {
  if (!process.env.REACT_APP_HOTJAR_ID) {
    window.hj = (...args: any[]) => {
      console.log('hotjar', args);
    };
    return;
  }

  if (typeof window !== 'undefined') {
    const script = document.createElement('script');

    script.innerHTML = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${process.env.REACT_APP_HOTJAR_ID},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;

    document.getElementsByTagName('head')[0].appendChild(script);
  }
};

export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>,
) => {
  if (typeof window !== 'undefined' && window.hj) {
    window.hj('event', eventName, properties);
  }
};

export const identifyUser = (
  userId: string,
  userProperties?: Record<string, any>,
) => {
  if (typeof window !== 'undefined' && window.hj) {
    window.hj('identify', userId, userProperties);
  }
};
